import i18n from 'i18next';

export default ({ onSubmit = () => {}, videoProperties = {} } = {}) => {
  const { data, isFetching } = videoProperties;
  const hasUrl = data?.enrollment?.enrollment_url;

  return {
    enrollment_url: {
      type: 'Text',
      label: i18n.t('enrollment-url'),
      help: i18n.t('enrollment-url-help'),
      isDisabled: true,
    },
    enrollment_url_buttons: {
      type: 'Buttons',
      isDecoration: true,
      buttons: [
        {
          isDisabled: isFetching,
          onClick: () => onSubmit({ modifiedModel: { regenerate_token: true } }),
          text: i18n.t(hasUrl ? 'regenerate-url' : 'generate-url'),
          variant: 'outlined',
        },
        {
          isDisabled: isFetching || !hasUrl,
          onClick: () => onSubmit({ modifiedModel: { deactivate_token: true } }),
          text: i18n.t('deactivate-url'),
          variant: 'ghost',
        },
      ],
    },
    attendance_max: {
      type: 'Number',
      label: i18n.t('attendance-max'),
      help: i18n.t('attendance-max-help'),
      shouldHideInputLabel: true,
      validators: [{ type: 'isNumber' }, { type: 'isPositiveInteger' }],
    },
    enforce_attendance_max: {
      type: 'Boolean',
      labelText: i18n.t('enforce-attendance-max'),
    },
    has_waitlist: {
      type: 'Boolean',
      label: i18n.t('has-waitlist'),
      labelText: i18n.t('has-waitlist-text'),
      conditions: [{ type: 'videos:isAttendanceMaxEmpty', shouldHideField: true }],
    },
    waitlist_max: {
      type: 'Number',
      label: i18n.t('waitlist-max'),
      shouldHideInputLabel: true,
      validators: [{ type: 'isNumber' }, { type: 'isPositiveInteger' }],
      conditions: [
        { type: 'videos:isAttendanceMaxEmpty', shouldHideField: true },
        { type: 'videos:isHasWaitlistNotSelected', shouldHideField: true },
      ],
    },
  };
};
